import { VStack, HStack, Icon, Badge } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

export const TargetSection = () => {
	const { t } = useTranslation();

	const personas = [
		{ icon: "Setting" as const },
		{ icon: "Upload" as const },
		{ icon: "Send" as const },
		{ icon: "Robot" as const },
	];

	return (
		<VStack className="w-full gap-[28px]">
			<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-strong font-semibold text-center">
				{t("home.target.title")}
			</h2>
			<p className="text-lg text-ct-regular font-medium text-center">{t("home.target.description")}</p>

			<HStack className="w-full gap-[20px] justify-center flex-col md:flex-row">
				{personas.map((persona, index) => (
					<motion.div
						key={index}
						className="w-full self-stretch"
						initial={{ opacity: 0, y: 30 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						transition={{ delay: index * 0.1, duration: 0.5 }}
					>
						<VStack className="gap-[16px] p-[24px] rounded-[16px] bg-bg-regular h-full">
							<Badge className="bg-pm-weak text-pm-strong">
								{t(`home.target.persona${index + 1}.badge`)}
							</Badge>
							<Icon name={persona.icon} width={48} height={48} className="text-pm-strong" />
							<h3 className="text-lg text-ct-strong font-semibold text-center">
								{t(`home.target.persona${index + 1}.title`)}
							</h3>
							<p className="text-md text-ct-regular font-medium text-center">
								{t(`home.target.persona${index + 1}.description`)}
							</p>
						</VStack>
					</motion.div>
				))}
			</HStack>
		</VStack>
	);
};
